var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},[_c('Echart',{ref:"centreLeft2ChartRef",attrs:{"id":"centreLeft2Chart","options":_vm.options,"height":"500px","width":"800px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }